export default "__VITE_ASSET__9e496081__"